export function markWordLinkTranslation(sentenceTranslation: string, wordLinkTranslation: string) {

    // replace '+' >> gab fehler bei 'adv/gerne - enjoy (+verb)

    const reg = new RegExp(`(^|[\\s"])${wordLinkTranslation.replace('+','')}([\\s.!,?']|$)`, 'i')
    const match = sentenceTranslation.match(reg)

    if (match) {
        const matchIndex = match.index
        if (matchIndex === undefined) return sentenceTranslation

        const index = match[0].startsWith(' ') || match[0].startsWith('"') ? matchIndex + 1 : matchIndex
        const length = wordLinkTranslation.length
        return sentenceTranslation.substring(0, index)
            + '<span class="word-link-translation">' + sentenceTranslation.substring(index, index + length) + '</span>'
            + sentenceTranslation.substring(index + length)
    } else {
        return sentenceTranslation
    }
}
